<img ngxGravatar
     class="d-inline-block"
     [email]="email"
     [tooltip]="tooltipText"
     [placement]="placement || 'auto'"
     [size]="avatarSize"
     [style.vertical-align]="'text-bottom'"
     [style.min-width.px]="avatarSize"
     [style.min-height.px]="avatarSize"/>
